import axios from 'axios'
import BaseService from './base'

export default class UserService extends BaseService {
    edit (id, body) {
        return axios.put(`${this.host}/users/${id}/`, body)
    }
}
